/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { SlideClassificationLesionLine } from './SlideClassificationLesionLine';

export type SlideClassification = {
    readonly id?: number;
    readonly slide_id?: number;
    status?: SlideClassification.status;
    readonly created_at?: string;
    readonly updated_at?: string;
    readonly ai_release?: string;
    readonly lesion_lines?: Array<SlideClassificationLesionLine>;
    /**
     * Determines if the AI has treated this slide as an excision or not
     */
    is_excision?: boolean | null;
}

export namespace SlideClassification {

    export enum status {
        ADDED = 'ADDED',
        SUBMITTED = 'SUBMITTED',
        PENDING = 'PENDING',
        RUNNABLE = 'RUNNABLE',
        STARTING = 'STARTING',
        RUNNING = 'RUNNING',
        SUCCEEDED = 'SUCCEEDED',
        FAILED = 'FAILED',
    }


}
